// https://codesandbox.io/s/dkicr?file=/demo.js
// https://codesandbox.io/s/autocomplete-demo-ixwq4?from-embed=&file=/src/App.js
// https://codesandbox.io/s/react-formik-material-ui-autocomplete-forked-bq3t5?file=/src/Component.tsx

import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { fieldToTextField } from "formik-material-ui";

function AutocompleteList({ textFieldProps, ...props }) {
  console.log("AutocompleteList : ", props);
  const {
    form: { setTouched, setFieldValue, touched, errors },
  } = props;
  const { error, helperText, options, ...field } = fieldToTextField(props);
  const { name,label } = field;

  // console.log("Auto Error Length: ", Object.keys(errors).length);
  // console.log("Auto Touched Lenght: ", Object.keys(touched).length);

  const [selectedState, setSelectedState] = useState(null);

  const handlePick2 = (e, v) => {
    console.log("handlePick2");
  };

  // const handlePick1 = (e, v) => {
  //   console.log("Auto: ", v);

  //   setSelectedState(v);
  //   // props.formikObj.setFieldValue(`${v.name}`, [{name:`${v.name}`,abbr:`${v.abbr}`}]);
  //   try {
  //     formikobj.setFieldValue("listofstates", [
  //       { name: `${v.name}`, abbr: `${v.abbr}` },
  //     ]);
  //   } catch (err) {
  //     formikobj.setFieldValue("listofstates", null);
  //     console.log("Autocomplete Error: ", err);
  //   }
  // };

  return (
    <div>
      <Autocomplete
        {...props}
        {...field}
        id={name}
        name={name}
        label={label}
        // options={props.states}
        value={selectedState}
        onChange={(_, value) => {
          console.log("Auto: ", value);
          // setFieldValue(name, value);
          setSelectedState(value);
          try {
            setFieldValue("listofstates", [
              { name: `${value.name}`, abbr: `${value.abbr}` },
            ]);
          } catch (err) {
            setFieldValue("listofstates", null);
            // console.log("Autocomplete Error: ", err);
          }
        }}
        // onBlur={() => setTouched({ [name]: true })}
        // getOptionLabel={(option) => (option ? option.name : "")}
        // getOptionSelected={(item, current) => item.value === current.value}
        renderInput={(props) => (
          <TextField
            {...props}
            {...textFieldProps}
            // helperText={helperText}
            // error={error}
          />
        )}
      />
      {/* {<div>{error}</div>} */}
      {Object.keys(touched).length > 0 && Object.keys(errors).length > 0 && (
        <div className="error">{helperText}</div>
      )}
    </div>
  );
}

export default AutocompleteList;
